import { Layout } from '@/components/layout';
import { EmptyState } from '@/components/atoms';
import { useBackButton } from '@/hooks';

export function BlockedPage(): JSX.Element {
  useBackButton();
  return (
    <Layout title="Заблоковані">
      <EmptyState icon="blocked" message="Список заблокованих клієнтів буде тут після першого блока." />
    </Layout>
  );
}
